import { useQuery } from '@apollo/client/react';
import { Table, Typography } from 'antd';
import dayjs from 'dayjs';
import { useState } from 'react';
import styled from 'styled-components';

import { Link } from 'react-router-dom';
import { Spacer } from '../../components/Spacer';
import { ADMIN_SUPPORT_MESSAGES } from '../../gqls/support-message';

const TAKE = 30;

export const PageSupportMessages = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, loading } = useQuery(ADMIN_SUPPORT_MESSAGES);

  const adminSupportMessages = data?.adminSupportMessages || [];
  const adminSupportMessagesCount = data?.adminSupportMessagesCount || 0;

  return (
    <>
      <Typography.Title level={5} style={{ margin: 0 }}>
        Обратная связь
      </Typography.Title>
      <Spacer h={12} />
      <ContentTable>
        <Table
          size="middle"
          loading={loading}
          dataSource={adminSupportMessages}
          columns={[
            {
              key: 'createdAt',
              dataIndex: 'createdAt',
              title: 'Дата создания',
              render: (date) => dayjs(date).format('DD.MM.YYYY HH:mm'),
            },
            {
              key: 'message',
              dataIndex: 'message',
              title: 'Сообщение',
            },
            {
              key: 'communication',
              dataIndex: 'communication',
              title: 'Контакт',
              render: (_, supportMessage) => {
                let type = 'Позвонить';
                if (supportMessage.communicationMethod === 'whatsapp') type = 'Написать WhatsApp';
                if (supportMessage.communicationMethod === 'email') type = 'Ответить на почту';
                return `${type} ${supportMessage.communicationValue}`;
              },
            },
            {
              key: 'userId',
              dataIndex: 'userId',
              title: 'Пользователь',
              render: (userId) => <Link to={`/users/${userId}`}>{userId.slice(0, 8)}...</Link>,
            },
          ]}
          pagination={{
            current: currentPage,
            total: adminSupportMessagesCount,
            pageSize: TAKE,
            onChange: (page) => {
              setCurrentPage(page);
            },
          }}
        />
      </ContentTable>
    </>
  );
};

const ContentTable = styled.div`
  overflow-x: auto;

  table {
    min-width: 1100px;
  }
`;
